class EnquiryDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#EnquiryDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.selectors = {
      form: ".enquiry-drawer__contact-form",
      formSuccess: ".enquiry-drawer__form-success"
    };
    this.identityFields = [
      {
        key: "$first_name",
        selector: "#ProductEnquiry-name"
      },
      {
        key: "$email",
        selector: "#ProductEnquiry-email"
      },
      {
        key: "$phone_number",
        selector: "#ProductEnquiry-phone"
      }
    ];
    this.enquiryFields = [
      {
        key: "product_name",
        selector: "#enquiryProductTitleInput"
      },
      {
        key: "product_id",
        selector: "#enquiryProductIdInput"
      },
      {
        key: "product_image",
        selector: "#enquiryProductImage"
      },
      {
        key: "variant_name",
        selector: "#enquiryVariantTitleInput"
      },
      {
        key: "variant_id",
        selector: "#enquiryVariantIdInput"
      },
      {
        key: "variant_price",
        selector: "#enquiryVariantPriceInput"
      },
      {
        key: "delivery_location",
        selector: "#ProductEnquiry-delivery-location"
      },
      {
        key: "notes",
        selector: "#ProductEnquiry-body"
      },
      {
        key: "custom_quote",
        selector: "#ProductEnquiry-custom-quote"
      },
      {
        key: "fabric_swatches",
        selector: "#ProductEnquiry-fabric-swatches"
      }
    ];

  }

  connectedCallback() {
    const enquiryForm = this.querySelector("form#ProductEnquiry");
    enquiryForm.addEventListener('submit', (event) => {
      event.preventDefault();
      this.submitFormToKlaviyo();
      return false
    });
  }

  getFieldValues(fields) {
     return fields.reduce((prev, curr) => {
      const element = this.querySelector(curr.selector);
      let value = "";
      if (element.type === "text" || element.type === "email" || element.type === "tel" || element.type === "textarea" || element.type === "hidden") {
        value = element.value;
      }
      if (element.type === "checkbox") {
        value = element.checked;
      }
      return {
        ...prev,
        [curr.key]: value
      }
    }, {})
  }

  pushToDataLayer(enquiryFields) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'generate_lead',
      'item_name': enquiryFields.product_name,
      'variant_name': enquiryFields.variant_name,
      'type': 'product_enquiry'
    });
  }

  submitFormToKlaviyo() {
    const _learnq = window._learnq || [];

    let identifyFields = this.getFieldValues(this.identityFields);

    if (identifyFields["$first_name"].includes(" ")) {
      const nameParts = identifyFields["$first_name"].split(" ");
      const firstName = nameParts[0];
      const lastName = nameParts.slice(1).join(" ");
      identifyFields = {
        ...identifyFields,
        ["$first_name"]: firstName,
        ["$last_name"]: lastName
      }
    }
    const enquiryFields = this.getFieldValues(this.enquiryFields);

    if (_learnq) {
      // Identify Profile
      _learnq.push(["identify", identifyFields]);
      // Push Enquiry to Klaviyo
      _learnq.push(["track", "Product Enquiry", enquiryFields, () => {
        this.showSuccess();
        this.pushToDataLayer(enquiryFields);
      }]);
    }
  }

  resetFieldValues(fields) {
    fields.forEach((field) => {
      const element = this.querySelector(field.selector);
      if (element.type === "text" || element.type === "email" || element.type === "tel" || element.type === "textarea") {
        element.value = "";
      }
      if (element.type === "checkbox") {
        element.checked = false;
      }
    });
  }

  setHeaderCartIconAccessibility() {
    const variantDrawerTriggers = document.querySelectorAll('.enquiry-drawer__trigger');
    variantDrawerTriggers.forEach((variantDrawerTrigger) => {
      variantDrawerTrigger.setAttribute('role', 'button');
      variantDrawerTrigger.setAttribute('aria-haspopup', 'dialog');
      variantDrawerTrigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(variantDrawerTrigger);
      });
      variantDrawerTrigger.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(variantDrawerTrigger);
        }
      });
    });
  }

  showSuccess() {
    const formElement = this.querySelector(this.selectors.form);
    const formSuccessElement = this.querySelector(this.selectors.formSuccess);
    formElement.classList.add("hidden");
    formSuccessElement.classList.remove("hidden");
  }

  reset() {
    const formElement = this.querySelector(this.selectors.form);
    const formSuccessElement = this.querySelector(this.selectors.formSuccess);
    formElement.classList.remove("hidden");
    formSuccessElement.classList.add("hidden");
    this.resetFieldValues(this.identityFields);
    this.resetFieldValues(this.enquiryFields);
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('EnquiryDrawer');
        const focusElement = this.querySelector('.enquiry-drawer__inner') || this.querySelector('.enquiry-drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    // document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    // document.body.classList.remove('overflow-hidden');
    this.reset();
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('enquiry-drawer', EnquiryDrawer);

